import React from 'react';

const Health = ({className, style, settings}) => (
  <div className={className} style={{...style,bottom:settings.bottom,right:settings.right}}>
    <svg width="36px" height="36px" viewBox="0 0 36 36" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink"><defs><circle id="a" cx={18} cy={18} r={18} /></defs><g transform="translate(-229.000000, -1088.000000) translate(49.000000, 1038.000000) translate(0.000000, 50.000000) translate(180.000000, 0.000000)" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd"><use fill="#A7D4EE" xlinkHref="#a" /><g transform="translate(5.806452, 6.387097)"><path d="M8.397.58l7.508.027a1.06 1.06 0 0 1 .968 1.15c-.154 1.755-.109 5.124.018 5.124h4.595c.64 0 1.16.553 1.16 1.232v6.855c0 .679-.52 1.232-1.16 1.232h-4.595c-.172 0-.311.149-.311.33v4.883c0 .68-.52 1.232-1.16 1.232H8.968c-.64 0-1.16-.553-1.16-1.232v-4.882c0-.182-.139-.331-.311-.331H2.902c-.64 0-1.16-.553-1.16-1.232V8.113c0-.68.52-1.232 1.16-1.232h4.595c.412-.104.383-.386.313-.001l-.033-5.481c-.005-.789.62-.818.62-.818zm.26 1.088V6.55c0 .678-.52 1.231-1.16 1.231H2.902c-.172 0-.312.148-.312.331v6.855c0 .182.14.33.312.33h4.595c.64 0 1.16.553 1.16 1.233v4.882c0 .183.139.33.31.33h6.453c.172 0 .312-.147.312-.33v-4.882c0-.68.52-1.233 1.159-1.233h4.595c.172 0 .311-.148.311-.33V8.113c0-.183-.139-.33-.31-.33H16.89c-.64 0-1.16-.554-1.16-1.232V1.668H8.657z" stroke="#333" /></g></g></svg>

  </div>
);

Health.defaultProps = {
  settings: {
    bottom:0,
    right:0,
  },
  style: {
    position:"absolute",
    zIndex:"500",
  },
};

export default Health;
